// extracted by mini-css-extract-plugin
export default {"autosFeeds":"AutosFeeds-module-autosFeeds","auroFeedSurveySection":"AutosFeeds-module-auroFeedSurveySection"};